import { apiRequest } from "@/services/api-client";
import { DeleteBoxInput, DeleteBoxOutput } from "types/web-app";

export const deleteBox = (input: DeleteBoxInput) =>
  apiRequest<DeleteBoxOutput>("/box/delete", {
    method: "POST",
    body: JSON.stringify(input),
  });
